import { addMethod, string } from 'yup';

import {
  validPhone,
  validPassword,
  validConfirmPassword,
} from '~utils/yupValidation';

declare module 'yup' {
  interface StringSchema {
    phone(message?: string): StringSchema;
    password(): StringSchema;
    confirmPassword(passwordFieldKey: string): StringSchema;
  }
}

addMethod(string, 'phone', validPhone);
addMethod(string, 'password', validPassword);
addMethod(string, 'confirmPassword', validConfirmPassword);
